import { TrackingSubscreen } from './types';
export const categoryToSubscreenMap = {
  all: TrackingSubscreen.ALL,
  'in-beta': TrackingSubscreen.IN_BETA,
  'in-development': TrackingSubscreen.IN_DEVELOPMENT,
  live: TrackingSubscreen.LIVE,
  'scheduled-for-release': TrackingSubscreen.SCHEDULED_FOR_RELEASE_TABLE,
  sunset: TrackingSubscreen.SUNSET,
  recommended: TrackingSubscreen.RECOMMENDED,
  'new-to-you': TrackingSubscreen.NEW_TO_YOU,
  'your-betas': TrackingSubscreen.YOUR_BETAS
};